<template>
  <div>
    <div class="table-tools">
      <h2 class="page-title" style="margin-bottom:0;">供应商管理</h2>
      <el-button @click="showPasswordDialog = true">修改管理员密码</el-button>
    </div>

    <div class="card-panel" style="padding:20px;margin-bottom:20px;">
      <el-form :model="form" label-position="top" class="form-grid">
        <el-form-item label="供应商登录编号">
          <el-input v-model="form.vendorCode" />
        </el-form-item>
        <el-form-item label="供应商短编号">
          <el-input v-model="form.shortCode" maxlength="4" placeholder="4位大写字母或数字" @input="form.shortCode = (form.shortCode || '').toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 4)" />
        </el-form-item>
        <el-form-item label="供应商类型">
          <el-select v-model="form.supplierType" placeholder="请选择供应商类型">
            <el-option v-for="item in supplierTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="供应商名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="头像/Logo">
          <div class="avatar-upload-row">
            <img v-if="avatarPreview" :src="avatarPreview" class="avatar-preview" alt="头像/Logo" />
            <el-upload :show-file-list="false" :http-request="uploadAvatar" accept="image/png,image/jpeg,image/webp">
              <el-button>上传头像/Logo</el-button>
            </el-upload>
            <el-button v-if="form.avatarUrl" type="text" @click="form.avatarUrl = ''">移除头像</el-button>
          </div>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" show-password />
        </el-form-item>
        <el-form-item label="特殊权限">
          <el-checkbox v-model="form.allowCreateSegments">可创建号段</el-checkbox>
        </el-form-item>
      </el-form>
      <el-divider content-position="left">{{ profileSectionTitle }}</el-divider>
      <el-form :model="form" label-position="top" class="form-grid">
        <template v-if="form.supplierType === 'individual'">
          <el-form-item label="联系人姓名">
            <el-input v-model="form.contactProfile.contactName" />
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input v-model="form.contactProfile.contactMethod" placeholder="电话、邮箱、QQ、微信等" />
          </el-form-item>
          <el-form-item label="联系邮箱">
            <el-input v-model="form.contactProfile.contactEmail" />
          </el-form-item>
          <el-form-item label="联系地址">
            <el-input v-model="form.contactProfile.contactAddress" />
          </el-form-item>
        </template>
        <template v-if="form.supplierType === 'circle'">
          <el-form-item label="社团名称">
            <el-input v-model="form.companyProfile.companyName" />
          </el-form-item>
          <el-form-item label="主理人">
            <el-input v-model="form.contactProfile.contactName" />
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input v-model="form.contactProfile.contactMethod" placeholder="电话、邮箱、QQ、微信等" />
          </el-form-item>
          <el-form-item label="社团平台/主页">
            <el-input v-model="form.companyProfile.businessScope" />
          </el-form-item>
        </template>
        <template v-if="form.supplierType === 'certified_company'">
          <el-form-item label="企业名称">
            <el-input v-model="form.companyProfile.companyName" />
          </el-form-item>
          <el-form-item label="统一社会信用代码">
            <el-input v-model="form.companyProfile.unifiedSocialCreditCode" />
          </el-form-item>
          <el-form-item label="法定代表人">
            <el-input v-model="form.companyProfile.legalRepresentative" />
          </el-form-item>
          <el-form-item label="注册地址">
            <el-input v-model="form.companyProfile.registeredAddress" />
          </el-form-item>
          <el-form-item label="营业执照编号">
            <el-input v-model="form.qualificationProfile.licenseNo" />
          </el-form-item>
          <el-form-item label="认证状态">
            <el-select v-model="form.qualificationProfile.status">
              <el-option v-for="item in qualificationStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </template>
      </el-form>
      <div style="display:flex;gap:12px;flex-wrap:wrap;">
        <el-button type="primary" @click="submit">{{ form.id ? '保存供应商' : '新建供应商' }}</el-button>
        <el-button v-if="form.id" @click="resetForm">取消编辑</el-button>
      </div>
    </div>

    <div class="card-panel" style="padding:20px;">
      <el-table :data="vendors" width="100%">
        <el-table-column prop="vendorCode" label="登录编号" />
        <el-table-column prop="shortCode" label="短编号" width="100" />
        <el-table-column prop="name" label="供应商名称" />
        <el-table-column label="类型" width="120">
          <template slot-scope="scope">
            <el-tag>{{ supplierTypeText(scope.row.supplierType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="认证状态" width="120">
          <template slot-scope="scope">
            <span>{{ qualificationStatusText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="特殊权限" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.allowCreateSegments ? '可创建号段' : '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isActive ? 'success' : 'info'">{{ scope.row.isActive ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="180" />
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button type="text" @click="editVendor(scope.row)">编辑</el-button>
            <el-button type="text" @click="openCard(scope.row)">名片</el-button>
            <el-button type="text" @click="toggleVendor(scope.row)">{{ scope.row.isActive ? '停用' : '启用' }}</el-button>
            <el-button type="text" style="color:#f56c6c;" @click="removeVendor(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="修改管理员密码" :visible.sync="showPasswordDialog" width="420px">
      <el-form :model="passwordForm" label-position="top">
        <el-form-item label="原密码">
          <el-input v-model="passwordForm.oldPassword" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password" show-password />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="submitPassword">确认修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { avatarAssetUrl, uploadAdminAvatar } from '../../api/avatar'
import { changeAdminPassword, createVendor, deleteVendor, getVendors, updateVendor } from '../../api/admin'

const supplierTypeOptions = [
  { label: '个人', value: 'individual' },
  { label: '同好社团', value: 'circle' },
  { label: '认证企业', value: 'certified_company' },
]

const qualificationStatusOptions = [
  { label: '待认证', value: 'pending' },
  { label: '已认证', value: 'approved' },
  { label: '未通过', value: 'rejected' },
]

const defaultForm = () => ({
  id: null,
  vendorCode: '',
  shortCode: '',
  name: '',
  avatarUrl: '',
  supplierType: 'individual',
  password: '',
  isActive: true,
  allowCreateSegments: false,
  contactProfile: {
    contactName: '',
    contactMethod: '',
    contactEmail: '',
    contactAddress: '',
  },
  companyProfile: {
    companyName: '',
    unifiedSocialCreditCode: '',
    legalRepresentative: '',
    registeredAddress: '',
    businessScope: '',
  },
  qualificationProfile: {
    licenseNo: '',
    licenseUrl: '',
    certificateUrl: '',
    status: 'pending',
  },
})

export default {
  data() {
    return {
      supplierTypeOptions,
      qualificationStatusOptions,
      form: defaultForm(),
      vendors: [],
      showPasswordDialog: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
      },
    }
  },
  computed: {
    profileSectionTitle() {
      return {
        individual: '个人基础资料',
        circle: '同好社团资料',
        certified_company: '企业认证资料',
      }[this.form.supplierType] || '供应商资料'
    },
    avatarPreview() {
      return avatarAssetUrl(this.form.avatarUrl)
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { data } = await getVendors()
      this.vendors = data
    },
    supplierTypeText(type) {
      const item = supplierTypeOptions.find(option => option.value === type)
      return item ? item.label : '个人'
    },
    qualificationStatusText(row) {
      if (row.supplierType !== 'certified_company') return '-'
      const status = row.qualificationProfile?.status || 'pending'
      const item = qualificationStatusOptions.find(option => option.value === status)
      return item ? item.label : '待认证'
    },
    resetForm() {
      this.form = defaultForm()
    },
    editVendor(row) {
      const baseForm = defaultForm()
      this.form = {
        ...baseForm,
        id: row.id,
        vendorCode: row.vendorCode,
        shortCode: row.shortCode,
        name: row.name,
        avatarUrl: row.avatarUrl || '',
        supplierType: row.supplierType || 'individual',
        password: '',
        isActive: row.isActive,
        allowCreateSegments: row.allowCreateSegments,
        contactProfile: { ...baseForm.contactProfile, ...(row.contactProfile || {}) },
        companyProfile: { ...baseForm.companyProfile, ...(row.companyProfile || {}) },
        qualificationProfile: { ...baseForm.qualificationProfile, ...(row.qualificationProfile || {}) },
      }
    },
    async toggleVendor(row) {
      try {
        await updateVendor(row.id, {
          vendorCode: row.vendorCode,
          shortCode: row.shortCode,
          name: row.name,
          avatarUrl: row.avatarUrl || '',
          supplierType: row.supplierType || 'individual',
          password: '',
          isActive: !row.isActive,
          allowCreateSegments: row.allowCreateSegments,
          contactProfile: row.contactProfile || {},
          companyProfile: row.companyProfile || {},
          qualificationProfile: row.qualificationProfile || {},
        })
        this.$message.success('状态已更新')
        this.loadData()
      } catch (error) {
        this.$message.error(error.response?.data?.message || '更新失败')
      }
    },
    openCard(row) {
      if (row.vendorCode) window.open(`/#/card/${row.vendorCode}`, '_blank', 'noopener,noreferrer')
    },
    async uploadAvatar(option) {
      try {
        const { data } = await uploadAdminAvatar(option.file)
        this.form.avatarUrl = data.avatarUrl
        this.$message.success('头像已上传，请保存供应商')
      } catch (error) {
        this.$message.error(error.response?.data?.message || '上传失败')
      }
    },
    async removeVendor(row) {
      if (!row?.id) {
        this.$message.error('供应商不存在')
        return
      }
      try {
        await this.$confirm(`确认删除供应商 ${row.name || row.vendorCode}？`, '提示', {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
        })
        await deleteVendor(row.id)
        this.$message.success('删除成功')
        this.loadData()
        if (this.form.id === row.id) this.resetForm()
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(error.response?.data?.message || '删除失败')
      }
    },
    async submit() {
      try {
        if (this.form.id) {
          await updateVendor(this.form.id, this.form)
          this.$message.success('更新成功')
        } else {
          await createVendor(this.form)
          this.$message.success('创建成功')
        }
        this.resetForm()
        this.loadData()
      } catch (error) {
        this.$message.error(error.response?.data?.message || '操作失败')
      }
    },
    async submitPassword() {
      try {
        await changeAdminPassword(this.passwordForm)
        this.$message.success('密码修改成功，请牢记新密码')
        this.passwordForm = { oldPassword: '', newPassword: '' }
        this.showPasswordDialog = false
      } catch (error) {
        this.$message.error(error.response?.data?.message || '修改失败')
      }
    },
  },
}
</script>

<style scoped>
.avatar-upload-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.avatar-preview {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  object-fit: cover;
  border: 1px solid #e5e7eb;
}
</style>
